import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MaleAvatar from "../Assets/AvatarImages/maleavatar.png";
import FemaleAvatar from "../Assets/AvatarImages/femaleavatar.png";
import "../css.css"; 
import "./test-aisle-web.css"; 
import "../uiux.css"; 
import Footer from './Footer';
import { getCurrentAccount} from "../azure-auth";
import Header from "./Header";

const TestAisleWeb = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Fixed syntax: replaced | with =

  useEffect(() => {
    const account = getCurrentAccount();
    if (!account) {
      navigate("/");
    } else {
      setUser(account);
    }
    setLoading(false);
  }, [navigate]);

  const handleAvatarSelection = (avatarType) => {
    if (avatarType === "male") {
      navigate("/test-aisle-web-male");
    } else if (avatarType === "female") {
      navigate("/test-aisle-web-female");
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!user) return null;


  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
      <Header/>
      
      <h1>Select Your Assistant</h1>
      {/* <button className="logout-button" onClick={handleLogout} style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: "5px" }}>
        <FaSignOutAlt /> Log Out
      </button> */}




      <div className="agents-grid">
        <div
          className="agent-card"
          onClick={() => handleAvatarSelection("male")}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && handleAvatarSelection("male")}
        >
          <img src={MaleAvatar} alt="Male Avatar Icon" className="avatar-icon" />
          <div className="agent-name">Nex</div>
        </div>
        <div
          className="agent-card"
          onClick={() => handleAvatarSelection("female")}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && handleAvatarSelection("female")}
        >
          <img src={FemaleAvatar} alt="Female Avatar Icon" className="avatar-icon" />
          <div className="agent-name">Zara</div>
        </div>
      </div>

      <button className="Btn" onClick={() => navigate("/dashboard")}>
        <div className="sign">
          {/* Back Arrow Icon */}
          <svg viewBox="0 0 512 512">
             <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
          </svg>
        </div>
        <div className="text">Back</div>
      </button>
      <Footer />
      
    </div>
  );
};

export default TestAisleWeb;